import { render, staticRenderFns } from "./MvpList.vue?vue&type=template&id=f8a63e18&lang=pug"
import script from "./MvpList.vue?vue&type=script&lang=js"
export * from "./MvpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a63e18')) {
      api.createRecord('f8a63e18', component.options)
    } else {
      api.reload('f8a63e18', component.options)
    }
    module.hot.accept("./MvpList.vue?vue&type=template&id=f8a63e18&lang=pug", function () {
      api.rerender('f8a63e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/MvpList.vue"
export default component.exports